<template>
  <div id="app">
    <Main v-if="auid !== undefined" />
    <Login v-if="auid === undefined" />    
    
  </div>
</template>

<script>
const Main = () => import(
  /* webpackChunkName: "main" */ '@/pages/Main.vue'
);
const Login = () => import(
  /* webpackChunkName: "login" */ '@/pages/Login.vue'
);
// import Main from '@/pages/Main.vue'
// import Login from '@/pages/Login.vue'
export default {
  name: 'App',
  data() {
    return {
      auid : undefined,
    }
  },
  created: function(){
    this.setup();
  },
  beforeCreate: function(){
    
  },
  methods: {
    setup: function(){
      this.$axios.get('/ts')
      .then(()=>{
        this.auid = this.$_auid
      })
      .catch((e)=>{
        //Not logged in
      })
    }
  },
  components: { Main, Login }
}
</script>

<style>

</style>
